import React from "react";
import { StyledSearchBar } from "../styledComponent/styledSearchBar";
import { MdOutlineSearch } from "react-icons/md";

export default function Searchbar(props) {
  const search = (event) => props.onSearch(event.target.value);

  return (
    <StyledSearchBar
      prefix={<MdOutlineSearch size={20} />}
      size="middle"
      placeholder={"Search Anything"}
      onPressEnter={search}
      onChange={props.onChange}
      disabled={props.disabled}
      value={props.value}
      allowClear
    />
  );
}
